import React, { createContext } from 'react';
import {
  TransactionSearchRequest,
  ViewContextProviderProps,
  ViewState,
  WithAppContextProps,
} from '../../types';
import { viewContextReducer } from './reducers/viewContextReducer';
import { ViewStateEnum } from './viewStateEnum';
import { transactionSearchRequestContextReducer } from './reducers/transactionSearchRequestContextReducer';
import { getKnownLanguages } from '../common/utils';

const defaultState: ViewState = {
  state: ViewStateEnum.FILL_MAIN_TRANSACTION_DATA,
};

const defaultTransactionSearchRequest: TransactionSearchRequest = {
  amount: '',
  currency: '',
  transactionDate: '',
  paymentMethod: '',
  identifier: '',
  email: '',
};

const AppContext = createContext<WithAppContextProps | undefined>(undefined);

const useAppContext = () => {
  const context = React.useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within a AppProvider');
  }

  return context;
};

const AppContextProvider = ({
                              children,
                              viewStateInitValue,
                              transactionSearchRequestInitValue,
                            }: ViewContextProviderProps) => {
  const [viewState, viewDispatch] = React.useReducer(viewContextReducer, {
    ...defaultState,
    ...viewStateInitValue,
  });

  const [language, setLanguage] = React.useState(() => getKnownLanguages()[0]);
  if(language == null || language == ''){setLanguage("en");}

  const [transactionSearchRequest, transactionSearchRequestDispatch] =
      React.useReducer(transactionSearchRequestContextReducer, {
        ...defaultTransactionSearchRequest,
        ...transactionSearchRequestInitValue,
      });

  const value = {
    viewState,
    viewDispatch,
    language,
    setLanguage,
    transactionSearchRequest,
    transactionSearchRequestDispatch,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export { AppContextProvider, useAppContext };
